(function () {
  function initFaq(section) {
    const tabs = Array.prototype.slice.call(section.querySelectorAll('.pf-faq__tab'));
    const panels = Array.prototype.slice.call(section.querySelectorAll('.pf-faq__panel'));
    const mobileQuery = window.matchMedia('(max-width: 989px)');

    function resetPanel(panel) {
      const items = panel.querySelectorAll('.pf-faq__item');
      items.forEach(function (item, i) {
        const open = i === 0;
        item.classList.toggle('is-open', open);
        const btn = item.querySelector('.pf-faq__q');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const key = tab.getAttribute('data-tab');

        tabs.forEach(function (t) {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          const active = panel.getAttribute('data-panel') === key;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.removeAttribute('hidden');
            resetPanel(panel);
          } else {
            panel.setAttribute('hidden', '');
          }
        });

        if (mobileQuery.matches) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    section.addEventListener('click', function (e) {
      const btn = e.target.closest('.pf-faq__q');
      if (!btn || !section.contains(btn)) return;
      const item = btn.closest('.pf-faq__item');
      const panel = btn.closest('.pf-faq__panel');
      if (!item || !panel) return;

      const wasOpen = item.classList.contains('is-open');

      panel.querySelectorAll('.pf-faq__item').forEach(function (it) {
        it.classList.remove('is-open');
        const q = it.querySelector('.pf-faq__q');
        if (q) q.setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  document.querySelectorAll('.pf-faq').forEach(initFaq);

  document.addEventListener('shopify:block:select', function (e) {
    const item = e.target.closest('.pf-faq__item');
    if (!item) return;
    const section = item.closest('.pf-faq');
    const panel = item.closest('.pf-faq__panel');
    if (!section || !panel) return;

    const tab = section.querySelector('.pf-faq__tab[data-tab="' + panel.getAttribute('data-panel') + '"]');
    if (tab && !tab.classList.contains('is-active')) tab.click();

    const btn = item.querySelector('.pf-faq__q');
    if (btn && !item.classList.contains('is-open')) btn.click();
  });

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.pf-faq');
    if (section) initFaq(section);
  });
})();
